import { course } from "../client";

export const getCourse = (params) => {
  console.log(params,"ans1")
  const user = {
    flag: "getCourse",
    parameters: {
      course: params.course,
    },
  };
  return course.post("/get/all/courses", user);
};

export const addCourse = (params) => {
  const user = {
    flag: "addCourse",
    parameters: {
      course: params.course,
      institutionId:params.institutionId
    },
  };
  return course.post("/add/course", user);
};

export const updateCourse = (params) => {
  const user = {
    flag: "updateCourse",
    parameters: {
      course: params.course,
    },
  };
  return course.post("/update/course", user);
};

export const getProgram = (params) => {
  const user = {
    flag: "getProgram",
    parameters: {
      course: params.course,
    },
  };
  return course.post("/get/programs", user);
};

export const getDepartment = (params) => {
  const user = {
    flag: "getDepartment",
    parameters: {
      department: params.department,
    },
  };
  return course.post("/get/departments", user);
};

export const deleteCourse = (params) => {
  const user = {
    flag: "deleteCourse",
    parameters: {
      course: params,
    },
  };
  return course.delete("/delete/course", { data: user });
};
